import { useEffect, useState } from "react";
import { DeleteRedIcon, EditIcon, FilterIcon, PlusThickWhiteIcon } from "../../../assets/icons";
import AddLocationAreaView from "./AddLocationAreaView";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { LocationAreaTableInfoDTO } from "../../../models/locationArea/locationArea.response";
import { localService } from "../../../services/localService";
import { locationAreaService } from "../../../services/locationAreaService";
import EditLocationAreaView from "./EditLocationAreaView";
import { confirmDialog } from "../../../utils/confirmDialog";


export default function LocationAreaSettingsPage() {

    const [isAddLocationAreaViewOpen, setIsAddLocationAreaViewOpen] = useState(false);
    const [isEditLocationAreaViewOpen, setIsEditLocationAreaViewOpen] = useState(false);
    const [selectedLocationAreaId, setSelectedLocationAreaId] = useState<string | null>(null);
    const [locationAreas, setLocationAreas] = useState<LocationAreaTableInfoDTO[]>([]);

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchLocationAreas();
    }, []);


    const fetchLocationAreas = async () => {
        setLoading(true);
        try {
            const response = await locationAreaService.getTableInfo();
            if (response.success && response.data) {
                setLocationAreas(response.data);
            } else {
                notify("error", "Error Fetching Location Areas", "An error occurred while fetching location areas.");
            }
        } catch (error) {
            notify("error", "Error Fetching Location Areas", "An error occurred while fetching location areas.");
        }
        finally {

            setLoading(false);
        }
    };

    const handleDeleteLocationArea = async (id: string) => {

        let confirm = await confirmDialog({
            title: "Da li ste sigurni da želite da obrišete ovu lokaciju?",
            description: "Ova akcija je nepovratna.",
            isDelete: true,
        });

        if (!confirm) {
            return;
        }

        setLoading(true);
        try {
            const response = await locationAreaService.Delete(id);

            if (response.success) {
                notify("success", "Location Area Deleted", "The location area has been deleted successfully.");
                fetchLocationAreas();
            } else {
                notify("error", "Error Deleting Location Area", response.message || "An error occurred while deleting the location area.");
            }
        } catch (error) {
            notify("error", "Error Deleting Location Area", "An error occurred while deleting the location area.");
        }
        finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }

    return (
        <>
            {isAddLocationAreaViewOpen && (
                <AddLocationAreaView
                    onClose={() => {
                        setIsAddLocationAreaViewOpen(false);
                        fetchLocationAreas();
                    }}
                />
            )}

            {isEditLocationAreaViewOpen && selectedLocationAreaId && (
                <EditLocationAreaView
                    id={selectedLocationAreaId}
                    onClose={() => {
                        setIsEditLocationAreaViewOpen(false);
                        fetchLocationAreas();
                    }}
                />
            )}

            <section className="sa-settings-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Lokacije</h2>
                                <div className="text-block">Pregled svih lokacija od gradova</div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddLocationAreaViewOpen(true)}>
                                    <img loading="lazy" src={PlusThickWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Nova Lokacija</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Gradovi</div>
                                    <div className="list-header-description">
                                        Upravljajte lokacijama unutar gradova<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="subcategory-header-filter-image" />
                                    <div className="list-header-filer-form w-form">
                                        <form className="form">
                                            <input className="form-input w-input" placeholder="Pretrazi lokacije..." />
                                            <select id="field-8" name="field-8" data-name="Field 8" className="form-select w-select">
                                                <option value="">Sve članarine</option>
                                            </select>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="list-row-div list-header-row cities">
                                    <div>Naziv</div>
                                    <div>Grad</div>
                                    <div>Slug</div>
                                    <div>Broj Lokala</div>
                                    <div id="w-node-_67b68af9-4b99-1090-fe9a-c7e62d0dcb88-7969b2d6">Akcije</div>
                                </div>

                                {locationAreas.map((locationArea) => (
                                    <div className="list-row-div cities" key={locationArea.id}>
                                        <div className="sa-locals-local-user-div">
                                            <div className="bold">{locationArea.name}</div>
                                        </div>
                                        <div className="small-box-div black-bg">
                                            <div>{locationArea.cityName}</div>
                                        </div>
                                        <div className="small-box-div grey-bg">
                                            <div>{locationArea.slug}</div>
                                        </div>
                                        <div className="sa-locals-local-user-div">
                                            <div>{locationArea.localCount} lokala</div>
                                        </div>
                                        <div id="w-node-_67b68af9-4b99-1090-fe9a-c7e62d0dcb97-7969b2d6" className="table-row-action-btns-div">
                                            <img loading="lazy" src={EditIcon} alt="" className="category-list-div-row-actions-image"
                                                onClick={() => {
                                                    setSelectedLocationAreaId(locationArea.id);
                                                    setIsEditLocationAreaViewOpen(true);
                                                }}
                                            />
                                            <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                                                onClick={() => handleDeleteLocationArea(locationArea.id)}
                                            />
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}